import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteProduct } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.DELETE,
  api: deleteProduct,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/products/DeleteAction.js